import Const from 'constants';

let TeamsStacks = {
    setExposureMaxOfTeamStacks(exposureMaxPercent, teamName, groupNumber) {
        return {
            type: Const.SET_EXPOSURE_MAX_OF_TEAM_STACKS,
            exposureMaxPercent,
            teamName,
            groupNumber,
        };
    },
};

export default TeamsStacks;
